var _filter, _filter2, _filter3, _rect, _line, _line2, _line3, _line4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _polygon, _line5, _line6, _rect2, _text, _text2, _rect3, _text3, _text4, _rect4, _text5, _text6, _rect5, _text7, _rect6, _rect7, _rect8, _rect9, _text8, _text9, _text0, _text1, _circle8, _circle9, _circle0, _circle1, _text10, _text11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f0c29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#1a1a4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f0c29"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ball",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f472b6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#a855f7"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cursor",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#38bdf8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6366f1"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glow2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodColor: "#000",
    floodOpacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 600,
    y2: 400,
    stroke: "#ffffff04",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 0,
    x2: 0,
    y2: 400,
    stroke: "#ffffff04",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 400,
    stroke: "#ffffff04",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 600,
    y2: 200,
    stroke: "#ffffff04",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 200,
    fill: "none",
    stroke: "#ffffff04",
    strokeWidth: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 140,
    fill: "none",
    stroke: "#ffffff05",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 80,
    fill: "none",
    stroke: "#ffffff06",
    strokeWidth: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 140,
    r: 28,
    fill: "url(#ball)",
    filter: "url(#glow1)",
    opacity: 0.95
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 134,
    r: 8,
    fill: "white",
    opacity: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 135,
    r: 38,
    fill: "none",
    stroke: "#f472b630",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 135,
    r: 52,
    fill: "none",
    stroke: "#f472b615",
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "370,185 378,178 386,185",
    fill: "url(#cursor)",
    filter: "url(#glow2)",
    opacity: 0.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 184,
    x2: 380,
    y2: 196,
    stroke: "url(#cursor)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 386,
    y1: 185,
    x2: 415,
    y2: 158,
    stroke: "#38bdf840",
    strokeWidth: 1,
    strokeDasharray: "4 3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 110,
    height: 50,
    rx: 12,
    fill: "#0f172a",
    filter: "url(#shadow)",
    stroke: "#6366f130",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 52,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 10
  }, "Score")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 70,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold"
  }, "247")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 30,
    width: 110,
    height: 50,
    rx: 12,
    fill: "#0f172a",
    filter: "url(#shadow)",
    stroke: "#f472b630",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 52,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 10
  }, "Best")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 70,
    fill: "#f472b6",
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold"
  }, "389")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 30,
    width: 260,
    height: 50,
    rx: 12,
    fill: "#0f172a",
    filter: "url(#shadow)",
    stroke: "#ffffff08",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 52,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 10,
    textAnchor: "middle"
  }, "Time Left")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 70,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "00:42")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 320,
    width: 540,
    height: 50,
    rx: 12,
    fill: "#0f172a",
    filter: "url(#shadow)",
    stroke: "#ffffff06",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 342,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 10,
    textAnchor: "middle"
  }, "Difficulty")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 350,
    width: 100,
    height: 6,
    rx: 3,
    fill: "#6366f1",
    opacity: 0.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 350,
    width: 100,
    height: 6,
    rx: 3,
    fill: "#6366f1",
    opacity: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 350,
    width: 100,
    height: 6,
    rx: 3,
    fill: "#6366f1",
    opacity: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 350,
    width: 100,
    height: 6,
    rx: 3,
    fill: "#1e293b"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 368,
    fill: "#6366f1",
    fontFamily: "Arial",
    fontSize: 9
  }, "Easy")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 225,
    y: 368,
    fill: "#6366f1",
    fontFamily: "Arial",
    fontSize: 9,
    textAnchor: "middle"
  }, "Medium")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 355,
    y: 368,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 9,
    textAnchor: "middle"
  }, "Hard")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 368,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 9,
    textAnchor: "middle"
  }, "Insane")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 280,
    r: 10,
    fill: "url(#ball)",
    opacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 240,
    r: 7,
    fill: "url(#ball)",
    opacity: 0.2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 300,
    r: 8,
    fill: "url(#ball)",
    opacity: 0.2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 180,
    r: 5,
    fill: "url(#ball)",
    opacity: 0.15
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 220,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: "bold",
    textAnchor: "middle",
    opacity: 0.06
  }, "CATCH")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 255,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: "bold",
    textAnchor: "middle",
    opacity: 0.06
  }, "THE BALL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtb);
export default __webpack_public_path__ + "static/media/ctb.5c0906f616e05f9a5ea4617f955bfe7b.svg";
export { ForwardRef as ReactComponent };